import Vuex from 'vuex';

export function createStore() {
    return new Vuex.Store({
        state : {
        }
    });
}